import buttonStyles from "../components/Button/Button.module.scss";
import { GridUIConfig } from "@aleksundshantu/aunds-utils-react/primitives/grid";
import styles from "./gridUIConfig.module.scss";

export const gridUIConfig: GridUIConfig = {
  classNames: {
    loadMoreButtonBase: buttonStyles.btn + " " + styles["load-more"] + " ",
    // + animationStyles["primary-slide-animation"],
    loadMoreButtonVariant: {
      "is-primary": buttonStyles["is-primary"],
      "is-secondary": buttonStyles["is-secondary"],
    },
    loadMoreWrapper: styles["load-more-wrapper"],
    paginationWrapper: styles["pagination-wrapper"],
    navNext: styles["nav-next"],
    navPrev: styles["nav-prev"],
  },
  components: {
    // Pagination: CustomPagination,
  },
  iconKeyMap: {
    loadMore: "altArrowRight",
    arrowPrev: "arrowRightGrid",
    arrowNext: "arrowRightGrid",
  },
};
